import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  Input,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { MultiSelectModule } from 'primeng/multiselect';
import { ClientsTableComponent } from '../../../../clients-table/clients-table.component';
import { ConstitutionAdministrationStore } from '../../stores/constitution-administration.store';
import { Router } from '@angular/router';
import { navigateToRelatedClient } from '../../../../../core/utils/client-navigation.util';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { faTrashCan } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-constitution-administration-section',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DropdownModule,
    CalendarModule,
    CheckboxModule,
    InputTextModule,
    InputNumberModule,
    MultiSelectModule,
    ClientsTableComponent,
    FontAwesomeModule,
    InputTextareaModule,
  ],
  templateUrl: './constitution-administration-section.component.html',
  styleUrl: '../../constitution-form.component.scss',
})
export class ConstitutionAdministrationSectionComponent {
  clientId = input<number | null>(null);
  activeTab = input<string>('constitution');
  deferPersistence = input(false);
  readonly store = inject(ConstitutionAdministrationStore);
  private readonly router = inject(Router);
  faTrash = faTrashCan;

  onAdminSystemChange(event: any): void {
    void this.store.onAdminSystemChange(event?.value ?? null, this.clientId());
  }

  saveMember(): void {
    this.store.saveMember(this.clientId(), this.deferPersistence());
  }

  goToMemberDetail(index: number): void {
    const member = this.store.members()[index] as any;
    const personId = member?.client ?? member?.associatedClient ?? null;
    if (personId) {
      navigateToRelatedClient(this.router, personId, this.activeTab() || 'constitution');
    }
  }
}
